<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
        >
        </go-lotus-side-menu>

        <div class="col-12 col-md-10 main-content position-relative">
            <patients-main :user="user" :organization="organization"></patients-main>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import PatientsMain from "./patients/PatientsMain";
import ClientListWidget from "./widgets/ClientListWidget/ClientListWidget";
import { sideMenuItems } from "../plugins/sideMenuItems";

export default {
    name: "Patients",
    props: ["user", "organization"],
    mixins: [sideMenuItems],
    components: {
        GoLotusSideMenu,
        PatientsMain,
        ClientListWidget,
    },
    data() {
        return {};
    },
};
</script>

<style scoped></style>
